<div class="modal-header border-bottom-0">
  <h4 class="modal-title body-bold-16 slate-600">
    {{title}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <app-close-icon></app-close-icon>
  </button>
</div>
<div class="modal-body">
  <p class="text">
    {{text}}
  </p>
</div>
<div class="modal-footer border-top-0">
  <div class="actions m-0">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close click')">
      {{'general.cancel' | translate}}
    </button>
    <button type="button" class="btn btn-primary mx-16" (click)="confirm()">
      {{'general.confirm' | translate}}
    </button>
  </div>
</div>